export default __webpack_public_path__ + "static/media/restaurantMobile.4267416e.jpg";